module.exports = __webpack_public_path__ + "static/logoUE-EN-90bd745d8293914945bbdb073dbc28e4.svg";